import type { MarketId } from '@ps/isp-web-services-types';
import { notEmpty } from '@ps/web-core-utils';
import { useSelector } from 'react-redux';

import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';

const useGetMarket = ({ marketId, marketIds }: { marketId?: MarketId; marketIds?: MarketId[] }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();

  const markets = useSelector(widgetSelect.markets);

  return marketId
    ? markets[marketId]
    : marketIds
    ? marketIds.map((mktId) => markets[mktId]).filter(notEmpty)[0]
    : undefined;
};

export default useGetMarket;
